<script>
import * as LucideIcons from 'lucide-vue-next'

export default {
  name: 'LegacyStatBox',
  props: {
    name: { type: String, default: '' },
    number: { type: [String, Number], default: '' },
    currency: { type: String, default: '' },
    icon: { type: String, default: '' },
  },
  computed: {
    iconComponent() {
      return this.icon ? LucideIcons[this.icon] : null
    },
  },
}
</script>

<template>
  <div class="rounded-xl border border-border bg-card text-card-foreground p-4 shadow-sm">
    <div class="flex items-center justify-between mb-2">
      <p class="text-xs uppercase tracking-wide text-muted-foreground">{{ name }}</p>
      <component
        v-if="iconComponent"
        :is="iconComponent"
        class="w-4 h-4 text-muted-foreground"
      />
    </div>
    <p class="text-2xl font-semibold text-foreground">
      <span v-if="currency">{{ currency }}</span>{{ number }}
    </p>
    <slot />
  </div>
</template>
